import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { ApiService } from '../../../service/api.service';
import { CoreService } from '../../../service/core.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-freight-type',
  templateUrl: './freight-type.component.html',
  styleUrls: ['./freight-type.component.css']
})
export class FreightTypeComponent implements OnInit {

  @ViewChild('closeModal', { static: false }) closeModal: ElementRef;
  resultobj: any = {};
  info = [];

  freight_type = {
    freight_id: '',
    freight_type_name:'',
    freight_type_ledger_id :'',
    
    
  }

  isSubmitInProg = false;
  curpage = 1;
  lastpage = 1;
  perpage = 20;
  totalItem = 0;
  curForm = 'Create';
  pageLoadingImg = false;
  langText = {
    create: '',
    update: ''
  };
  up: any;
  selecTed: any[];
  searchleadger: any;
  
  constructor(private apiService: ApiService, private coreService: CoreService, private translate: TranslateService,private modalService: NgbModal) { }

  ngOnInit() {
    this.translate.get(['Common.create', 'Common.update']).subscribe((res: string) => {
      this.langText.create = res['Common.create'];
      this.langText.update = res['Common.update'];
      this.curForm = this.langText.create;
      this.up = this.coreService.getUserPrivilage();
    });
    this.getInfo(this.curpage);
  }
  getInfo(pageNo) {
    this.pageLoadingImg = true;
    this.apiService.getAllFreightType(pageNo, this.perpage).subscribe((res) => {
      this.info = res.data;
      this.pageLoadingImg = false;
      this.curpage = res.current_page;
      this.lastpage = res.last_page;
      this.totalItem = res.total;
    });
  }

  createFreightType(){
    this.curForm = this.langText.create;
    this.clearForm();
  }

  searchLedger(search: string) {
    $('#report-wrapper').hide();

    const searchval = new FormData();
    searchval.append('search', search);
  
    this.apiService.searchLedgerList(searchval, 1).subscribe((res: any) => {
      this.searchleadger = res.data ? res.data.data : '';
      this.selecTed = [];
    });

  }

  clearForm() {
    this.freight_type = {
      freight_id: '',
      freight_type_name:'',
      freight_type_ledger_id :'',
    };
  }

  editFreightType(freight_id){
    this.curForm = this.langText.update;
    this.clearForm();
    this.resultobj = [];
    this.apiService.getFreightType({freight_id: freight_id}).subscribe((res) => {
     
     
       this.searchLedger(res.ledger_name);
      // console.log(res.ledger.ledger_name);
    
      this.freight_type = {
        freight_id: res.freight_type_id,
        freight_type_name: res.freight_type_name,
        freight_type_ledger_id :res.freight_type_ledger_id,
        
      };
    });
  }

  deleteFreightType(freight_id,curpage){
    if(confirm("Do you wish to void this entry?")){
      this.apiService.deleteFreightType({freight_id: freight_id}).subscribe((res) => {
        this.coreService.showMessage(res.message);
      });
      this.getInfo(curpage); 
    }
  
  }

  validateAndSubmit() {
    if (confirm('Do you wish to continue?')) {
      this.isSubmitInProg = true;
      let callFunction = '';
      if (this.curForm === this.langText.create) {
        callFunction = 'createFreightType';
      }
      if (this.curForm === this.langText.update) {
        callFunction = 'updateFreightType';
      }
      this.apiService[callFunction](this.freight_type).subscribe((res) => {

        console.log("holllllllaaaaaaaa");
        console.log(res);
        this.isSubmitInProg = false;
        if (res.error != null) {
          this.resultobj = res.error;
        } else {
          this.closeModal.nativeElement.click();
          this.getInfo(this.curpage);
          this.coreService.showMessage(res.message);
          this.clearForm();
          this.resultobj = {};
        }

      });
    }
}


}
